/** Main flight-mode heading on the race summary page (flight data). */
export const flightTimePercentagesRaceSummaryHeading =
  "Flight time percentages and average absolute variations [AAV]";

/** Appended to the "Flight time percentages" heading in flight mode (training / hour summaries). */
export const flightTimePercentagesAavExplanation =
  " AAV numbers are averaged for the race phases, time between maneuvers.";

/**
 * Parenthetical detail for "Flight time percentages (...)" in flight data mode.
 * RH LWD mm bands match `server_python/scripts/gp50/3_systems.py` (`_rh_twa_tier_flags`)
 * and `Race.py` (`_rh_band_series_from_height`).
 */
export function flightTimePercentagesLabelDetail(legType: string): string {
  const isDown = legType === "downwind";
  const ranges = isDown
    ? "RH LWD: LOW <300, MED [300–1100), GOOD [1100–1300), HIGH ≥1300 mm"
    : "RH LWD: LOW <300, MED [300–900), GOOD [900–1200), HIGH ≥1200 mm";
  const leg = isDown ? "downwind" : "upwind";
  return `for ${leg} legs; ${ranges}`;
}

/** Same as `flightTimePercentagesLabelDetail` with sentence case for use as a subtitle under the main heading. */
export function flightTimePercentagesCaption(legType: string): string {
  const d = flightTimePercentagesLabelDetail(legType);
  if (!d) return d;
  return d.charAt(0).toUpperCase() + d.slice(1);
}
